import React from "react";
import SectionHeader from "./SectionHeader";
import ScrollCarousel from "./ScrollCarousel";
import PromoTourCard from "./PromoTourCard";
import { OFFERS } from "../mock";

export default function SpecialOffers() {
  return (
    <section className="v2-section" id="special-offers-v2">
      <SectionHeader title="Special Offer" subtitle="Don't miss out on this limited-time deal!" viewAllHref="/web" />
      <ScrollCarousel trackClassName="v2-offers__track" step={290}>
        {OFFERS.map((offer) => (
          <PromoTourCard
            key={offer.id}
            variant="compact"
            image={offer.image}
            ribbon={offer.badge}
            brandLogo={offer.brandLogo}
            destination={offer.location}
            departFrom={offer.from}
            title={offer.title}
            guaranteed={offer.guaranteed}
            originalPrice={offer.originalPrice}
            save={offer.save}
            price={offer.price}
          />
        ))}
      </ScrollCarousel>
    </section>
  );
}
